(function() {

	var form = '#js-checkout-message-form';
	var $form = $(form);

	var textarea = '#js-checkout-message';
	var $textarea = $(textarea);

	var saveBtn = '#js-checkout-message-save-btn';
	var $saveBtn = $(saveBtn);

	var default_label = $saveBtn.data('default-label');
	var saved_label = $saveBtn.data('saved-label');
	var loading_label = $saveBtn.data('loading-label');
	var changes_label = $saveBtn.data('changes-label');
	var delete_label = $saveBtn.data('delete-label');
	var deleted_label = $saveBtn.data('deleted-label');

	var message;
	var message_length;
	var submitted_message;
	var saves = 0;

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `changedFeedback`
	 *
	 * Let the user know that we detected changes in the message.
	 */
	function changedFeedback() {
		if( saves === 0 ) {
			$saveBtn.text( default_label );
		}
		else {
			$saveBtn.text( changes_label );
		}
	}

	/**
	 * @function `loadingFeedback`
	 *
	 * Let the user know that we are saving the message and prevent him
	 * to submit the form again.
	 */
	function loadingFeedback() {
		disableSaveButton();
		$saveBtn.text( loading_label );
	}

	/**
	 * @function `successFeedback`
	 *
	 * Let the user know that the message has been saved.
	 */
	function successFeedback() {
		if( message_length ) {
			$saveBtn.text( saved_label );
		}
		else {
			$saveBtn.text( deleted_label );
		}
	}

	/**
	 * @function `disableSaveButton`
	 *
	 * Disables the save (submit) button.
	 */
	function disableSaveButton() {
		$saveBtn.prop('disabled', true);
	}

	/**
	 * @function `enableSaveButton`
	 *
	 * Enables the save (submit) button.
	 */
	function enableSaveButton() {
		if( !$saveBtn.prop('disabled') ) {
			return;
		}
		$saveBtn.prop('disabled', false);
		changedFeedback();
	}

	/**
	 * @function `suggestMessageDeletion`
	 *
	 * Updates the label of the save button to "delete".
	 */
	function suggestMessageDeletion() {
		$saveBtn.text( delete_label );
	}

	/**
	 * @function `watchChanges`
	 * @example http://stackoverflow.com/a/11338644
	 *
	 * Enables/disables the save button if message changes.
	 *
	 * 1. If no message has ever been saved (submitted) and there's no text in
	 *    the box, disable the button.
	 * 2. If the text box has been emptied out after the user has already
	 *    submitted a message, suggest the deletion of the message.
	 * 3. Current message is exactly the same as the submitted message: let the
	 *    user know that this message is already saved and that there's no need
	 *    to submit the message again.
	 */
	function watchChanges() {
		$textarea.bind('input propertychange', function() {
			message = $(this).val();
			message_length = $(this).val().length;
			if( !message_length ) {
				if( !saves ) { /* [1] */
					disableSaveButton();
				}
				else { /* [2] */
					suggestMessageDeletion();
					enableSaveButton();
				}
			}
			else {
				if( message === submitted_message ) { /* [3] */
					disableSaveButton();
					successFeedback();
				}
				else {
					enableSaveButton();
					changedFeedback();
				}
			}
		});
	}

	/**
	 * @function `saveSubmittedMessage`
	 *
	 * Keep a record of the submitted message for comparison.
	 */
	function saveSubmittedMessage() {
		submitted_message = $textarea.val();
	}

	/**
	 * @function `submitSilently`
	 *
	 * Submits the form without reloading the page.
	 */
	function submitSilently( $form ) {
		loadingFeedback();
		$.ajax({
			url: $form.attr('action'),
			method: 'POST',
			data: $form.serializeArray(),
			headers: {
				'accept': 'application/json',
			},
			success: function(data) {
				successFeedback();
				saves++;
				saveSubmittedMessage();
			},
			error: function() {
				// TODO
			},
			complete: function() {
				// TODO
			}
		});
	}

	//	======================================================================  //
	//	On ready
	//	======================================================================  //

	onReady.callbacks.checkoutMessage = function() {
		disableSaveButton();
		watchChanges();
	};

	//	======================================================================  //
	//	On submission
	//	======================================================================  //

	$form.on('submit', function(e) {
		e.preventDefault();
		submitSilently( $(this) );
	});

})();
